var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.75C7.80653 6.75 6.66193 7.22411 5.81802 8.06802C4.97411 8.91193 4.5 10.0565 4.5 11.25V11.7023L18 18.972L31.5 11.7045V11.25C31.5 10.0565 31.0259 8.91193 30.182 8.06802C29.3381 7.22411 28.1935 6.75 27 6.75H9ZM31.5 14.2582L18.5333 21.24C18.3694 21.3282 18.1861 21.3744 18 21.3744C17.8139 21.3744 17.6306 21.3282 17.4668 21.24L4.5 14.2582V24.75C4.5 25.9435 4.97411 27.0881 5.81802 27.932C6.66193 28.7759 7.80653 29.25 9 29.25H27C28.1935 29.25 29.3381 28.7759 30.182 27.932C31.0259 27.0881 31.5 25.9435 31.5 24.75V14.2582Z",
    fill: "#2A2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6902e0bb18cc6de49f1bffc22ce4c8cb.svg";
export { ForwardRef as ReactComponent };